<div class="mt-10 mx-auto max-w-7xl px-2 sm:px-6">
  @if (!isInitializing()) {
  <activar-stepper>
    @for (step of quoterState().steps; track step.id) {
    <activar-step
      (click)="!step.disabled && quoterStateService.setActiveStep(step.id)"
      [active]="step.active"
      [disabled]="step.disabled"
      [completed]="step.completed"
    >
      {{ step.name }}
    </activar-step>
    }
  </activar-stepper>

  <!-- Step 1: Insured -->
  @if (quoterState().activeStep === 1) {
  <div class="content__wrapper">
    @if (!quoterState().isNewUser) {
    <h2>Completá los datos del tomador</h2>
    <div class="content__wrapper--center">
      <activar-card class="mt-5">
        <app-search-users
        label="Asegurado"
          (userSelected)="setUser($event)"

          [userTypes]="userTypes()"
          [userRoles]="userRoles()"
          [agentId]="quoterState().agent?.id ?? ''"
        />
        <activar-button
          color="default"
          class="mt-5 mb-5"
          fill="clear"
          expand="block"
          (click)="toggleCreateUserForm()"
          text="+ Nuevo"
        />
        @if (quoterState().user.id) {
        <activar-button
          text="Continuar"
          color="primary"
          expand="full"
          fill="solid"
          (click)="goToInsurableStep()"
        />
        }
      </activar-card>
    </div>
    } @else {
    <h2>Completá los datos del tomador</h2>
    <div class="content__wrapper--center">
      <app-create-user-form
        [userTypes]="userTypes()"
        (EventFormSubmit)="createUser($event)"
      />

      <div
        class="flex items-start justify-start mt-5 w-full"
        *showForChannels="['agents']"
      >
        <activar-back-button text="Volver" (click)="toggleCreateUserForm()" />
      </div>
    </div>
    }
  </div>
  }

  <!-- Step 2: insurable data -->

  <div class="content__wrapper" [hidden]="quoterState().activeStep !== 2">
    <h2>Completá los datos generales del seguro</h2>
    <div class="content__wrapper--center mt-5">
      <activar-card>
        <ng-container #dynamicComponentContainer></ng-container>
      </activar-card>
    </div>
  </div>

  <!-- Step 3: Quote result -->
  @if (quoterState().activeStep === 3) {
  <div class="content__wrapper">
    <h2>Encontramos éstos planes para vos</h2>
    <app-quoter-coverages-result [coverages]="quoterState().quote.coverages" [risk]="quoterState().risk.tag" [additionalCoverage]="quoterState().quote.additionalCoverage" [currency]="quoterState().currency" (coverageSelected)="setCoverage($event)"/>
  </div>
  }

  <!-- Step 4: Classic car inspection -->
  @if (quoterState().activeStep === 4) {
  <div class="content__wrapper">
    <ng-container *ngComponentOutlet="getDynamicComponent()" />
  </div>
  }

  <!-- Step 35: Prospect signup -->
  @if (quoterState().activeStep === PROSPECT_SIGNUP_STEP_ID) {
    <app-prospect-signup-step
      [user]="quoterState().user"
      (signupSuccess)="handleProspectSignupSuccess($event)"
    />
  }
  } @else {
  <app-risk-loader [riskTag]="loadingRiskTag()" />
  }
</div>


@if (quoterState().loadingOverlay) {
<activar-loading-overlay />
}

<activar-modal [(visible)]="showLoginModal" width="min(440px, 90vw)">
  <div class="flex flex-col p-5 text-center">
    <h2>Verificá tu identidad</h2>
    <p class="text-gray-500 mt-2">Ingresá el código que enviamos a tu email</p>
    <app-code-verification-form-component
      [isLoading]="loginLoading"
      [serverError]="loginError()"
      (formSubmit)="handleCodeSubmit($event)"
      (codeChanged)="loginError.set('')"
    />
    <activar-button
      fill="clear"
      color="default"
      text="Reenviar código"
      (click)="resendLoginCode()"
    />
  </div>
</activar-modal>

<ng-container #onboardingContainer></ng-container>
